import Cookies from "js-cookie";
import React, { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import { NavLink, useNavigate } from "react-router-dom";

const Login = () => {
  const formRef = useRef(null);
  const navigate = useNavigate();
  // State to track focus for each input
  const [isUsernameFocused, setIsUsernameFocused] = useState(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  let [iniVal, setIniVal] = useState({
    email: "",
    password: "",
  });
  useEffect(() => {
    const loginCheck = Cookies.get("logged_in");
    if (loginCheck) {
      navigate("/dashboard");
    }
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setIniVal(() => {
      return {
        ...iniVal,
        [name]: value,
      };
    });
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    const { email, password } = iniVal;
    try {
      const response = await fetch(SERVER_URL + `/api/users/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });
      const data = await response.json();
      // console.log(data);
      if (response.ok) {
        formRef.current.reset();
        Cookies.set("token", data.token);
        Cookies.set("users_id", data.users_id);
        Cookies.set("logged_in", "true");
        setTimeout(() => {
          toast.success(data.message);
          navigate("/dashboard");
        }, 1000);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };
  return (
    <>
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-stretch auth auth-img-bg">
          <div className="row flex-grow">
            <div className="col-lg-6 d-flex align-items-center justify-content-center">
              <div className="auth-form-transparent text-left p-3">
                <div className="brand-logo d-flex justify-content-center">
                  <img src="../../assets/images/kusum-logo.png" alt="logo" />
                </div>
                <h4>Welcome back!</h4>
                <h6 className="font-weight-light">Happy to see you again!</h6>
                <form className="pt-3" onSubmit={handleLogin} ref={formRef}>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail">Email</label>
                    <div className="input-group ">
                      <div className="input-group-prepend bg-transparent">
                        <span
                          className={`input-group-text bg-transparent border-right-0 ${
                            isUsernameFocused ? "border-color-focus" : ""
                          }`}
                        >
                          <i className="mdi mdi-account-outline text-primary" />
                        </span>
                      </div>
                      <input
                        type="text"
                        required
                        autoComplete="off"
                        className="form-control form-control-lg border-left-0"
                        id="exampleInputEmail"
                        name="email"
                        placeholder="Email"
                        onFocus={() => setIsUsernameFocused(true)}
                        onBlur={() => setIsUsernameFocused(false)}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputPassword">Password</label>
                    <div className="input-group">
                      <div className="input-group-prepend bg-transparent">
                        <span
                          className={`input-group-text bg-transparent border-right-0 ${
                            isPasswordFocused ? "border-color-focus" : ""
                          }`}
                        >
                          <i className="mdi mdi-lock-outline text-primary" />
                        </span>
                      </div>
                      <input
                        type="password"
                        required
                        autoComplete="off"
                        name="password"
                        className="form-control form-control-lg border-left-0"
                        id="exampleInputPassword"
                        placeholder="Password"
                        onFocus={() => setIsPasswordFocused(true)}
                        onBlur={() => setIsPasswordFocused(false)}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="my-2 d-flex justify-content-between align-items-center">
                    <div className="form-check">
                      {/* <label className="form-check-label text-muted">
                                                <input type="checkbox" className="form-check-input" />
                                                Keep me signed in
                                            </label> */}
                    </div>
                    <NavLink
                      to="/forgotpassword"
                      className="auth-link text-black"
                    >
                      Forgot password?
                    </NavLink>
                  </div>
                  <div className="my-3">
                    {/* <NavLink className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" to='/dashboard'>LOGIN</NavLink> */}
                    <button
                      type="submit"
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                    >
                      Login
                    </button>
                  </div>
                  {/* <div className="mb-2 d-flex">
                                        <button type="button" className="btn btn-facebook auth-form-btn flex-grow mr-1">
                                            <i className="mdi mdi-facebook mr-2" />Facebook
                                        </button>
                                        <button type="button" className="btn btn-google auth-form-btn flex-grow ml-1">
                                            <i className="mdi mdi-google mr-2" />Google
                                        </button>
                                    </div>
                                    <div className="text-center mt-4 font-weight-light">
                                        Don't have an account? <a href="register-2.html" className="text-primary">Create</a>
                                    </div> */}
                </form>
              </div>
            </div>
            <div
              className="col-lg-6 login-half-bg d-flex flex-row"
              style={{ filter: "opacity(0.9)" }}
            ></div>
          </div>
        </div>
        {/* content-wrapper ends */}
      </div>
    </>
  );
};

export default Login;
